
import React, { Component } from 'react'
import { configuration } from "../appConfig";
export class MobileApp extends Component {

    componentDidMount(){
        if(configuration.getVersionUrl === "https://drivenscan.com"){
            var a = document.createElement('a');
            a.target = '_blank';
            a.href = 'https://mobile.drivenscan.app/AppInterFaceMain'
            a.click()
            window.location.pathname='/dashboard'
        }else if(configuration.getVersionUrl === "https://backend.drivenscan.live"){
            var a = document.createElement('a');
            a.target = '_blank';
            a.href = 'https://mobile.drivenscan.live/'
            a.click()
            window.location.pathname='/dashboard'
        }else{
            var a = document.createElement('a');
            a.target = '_blank';
            a.href = 'https://drivenscan.de'
            a.click()
            window.location.pathname='/dashboard'
        }
    }
    render() {
        return (
            <>
            </>
        )
    }
}

export default MobileApp
